import React from "react"
import Link from "next/link"
import styles from "./styles.module.css"
import SmartImage from "./SmartImage"
import {buildArticleUrl, pickThumbnail, slugify} from "./utils"

export default function ArticleCard({context, article}) {
    if (!article) return null

    const href = buildArticleUrl(context, article.aid, slugify(article.title))
    const thumb = pickThumbnail(article)
    const initial = (article.title || "?").trim().charAt(0).toUpperCase()
    const section = article.section || (Array.isArray(article.breadcrumb) ? article.breadcrumb.slice(-1)[0] : null)
    const readingMin = article.word_count > 0 ? Math.max(1, Math.round(article.word_count / 200)) : null
    const externalUrl = article.url_source

    const inner = (
        <>
            <SmartImage
                src={thumb}
                alt={article.title || ""}
                className={styles.articleCardThumb}
                loading="lazy"
                fallback={<div className={styles.articleCardThumbPlaceholder}>{initial}</div>}
            />
            <div className={styles.articleCardBody}>
                {section && <div className={styles.articleCardSection}>{section}</div>}
                <h3 className={styles.articleCardTitle}>{article.title || `#${article.aid}`}</h3>
                {(readingMin || article.image_count > 0) && (
                    <div className={styles.articleCardMeta}>
                        {readingMin && <span>⏱ {readingMin} min</span>}
                        {article.image_count > 0 && <span>📷 {article.image_count}</span>}
                    </div>
                )}
            </div>
        </>
    )

    if (externalUrl) {
        return (
            <a className={styles.articleCard} href={externalUrl} target="_blank" rel="noopener noreferrer">
                {inner}
            </a>
        )
    }

    return (
        <Link href={href} passHref legacyBehavior>
            <a className={styles.articleCard}>{inner}</a>
        </Link>
    )
}
